import { cn } from 'utils/bem';

export const select = cn('select-next');
